import { useSelector } from "react-redux";
import { MODULE_NAME } from "../moduleName";
import { ActivityFeedState, GlobalState } from "../redux/state";

export const useActivityFeedState = (
  entityReferenceId: string | null | undefined
) => {
  const activityFeedState = useSelector<
    GlobalState,
    ActivityFeedState | null | undefined | ""
  >(
    (state) => {
      try {
        return entityReferenceId && state[MODULE_NAME].activityFeeds[entityReferenceId]
      } catch (e) {
        throw new Error(`Check you have included @ofqual/portal-activity-feed in your coreItems prop for Shell. Error: ${e}`)
      }
    }
  );

  return activityFeedState || null;
};
